import { avatar, praiseReport1, praiseReport2 } from "assets/images";
import { capitalizeFirstLetter } from "constants/textFormatters";
import PlayVideo from "generalComponents/PlayVideo";
import React, { forwardRef, useState } from "react";
import { twMerge } from "tailwind-merge";

const PraiseReportItem = forwardRef(
  (
    {
      avatar,
      fullname,
      time,
      title,
      image,
      likes,
      description,
      praiseReportData,
    },
    ref
  ) => {
    const [fullDescription, setFullDescription] = useState(false);
    return (
      <div
        ref={ref}
        className="py-6 [&>*]:px-5 mx-auto border-b border-b-gray-300 md:px-3"
      >
        <div className="flex items-center gap-2.5 w-fit mb-4">
          {praiseReportData?.anonymous ? (
            <div className="size-10 bg-black rounded-full"></div>
          ) : (
            <img src={avatar} alt="" className="w-10 h-10 rounded-full" />
          )}
          <div>
            <p className="font-medium text-[13px] text-[#1D1D1D]">
              {praiseReportData?.anonymous
                ? "Anonymous"
                : fullname !== ""
                ? fullname
                : `${capitalizeFirstLetter(
                    praiseReportData?.user?.first_name
                  )} ${capitalizeFirstLetter(
                    praiseReportData?.user?.last_name
                  )}`}
            </p>
            <p className="text-[10px] text-[#BDBDBD]">{time}</p>
          </div>
        </div>

        <p className="font-semibold text-xl text-purpleOverlay mb-2">{title}</p>
        <div className="relative !px-0">
          <img
            src={praiseReportData?.anonymous ? "" : image}
            alt=""
            className="w-full mb-3  max-h-[560px] object-cover bg-black"
          />{" "}
          <div className="absolute h-full w-full top-0 left-0 bg-gradient-to-b from-transparent to-black/50 z-[2]"></div>
          {praiseReportData?.mediaType === "video" ? (
            <svg
              role="button"
              onClick={() =>
                window[`report_${praiseReportData.id}`]?.showModal()
              }
              width="56"
              height="62"
              viewBox="0 0 56 62"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="absolute inset-0 m-auto z-[3]"
            >
              <path
                opacity="0.7"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 9.77249C0 2.22576 8.20024 -2.46434 14.705 1.36201L50.6633 22.514C57.0773 26.2869 57.0773 35.5622 50.6633 39.3349L14.705 60.487C8.20024 64.3133 0 59.6231 0 52.0765V9.77249Z"
                fill="white"
              />
            </svg>
          ) : null}
        </div>
        {/* <div className="flex items-center justify-between mb-2.5">
          <div className="flex items-center gap-1">
            <svg
              width="27"
              height="26"
              viewBox="0 0 27 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              role="button"
            >
              <path
                d="M18.2874 3.82715C16.7774 3.82715 15.389 4.33774 14.303 5.21094C13.5752 5.79611 12.3673 5.79611 11.6396 5.21094C10.5536 4.33774 9.16518 3.82715 7.65519 3.82715C4.14657 3.82715 1.27588 6.69784 1.27588 10.2065C1.27588 15.6653 9.98438 21.2034 12.3721 22.6192C12.7466 22.8413 13.1964 22.8421 13.5715 22.6212C15.9609 21.2143 24.6667 15.7104 24.6667 10.2065C24.6667 6.69784 21.796 3.82715 18.2874 3.82715Z"
                stroke="#2F0640"
                strokeWidth="1.5"
              />
            </svg>
            <span className="font-medium text-xs text-purpleOverlay">
              {likes} Likes
            </span>
          </div>
          <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="button"
          >
            <g clipPath="url(#clip0_839_17891)">
              <path
                d="M9.98715 16.7784L15.3192 11.4464M10.5349 17.6285L12.2921 21.1541C13.2491 23.0742 13.7275 24.0342 14.3439 24.3049C14.879 24.5401 15.4936 24.5099 16.0032 24.2234C16.59 23.8935 16.972 22.8913 17.7361 20.8866L22.642 8.01529C23.3891 6.05489 23.7628 5.07473 23.55 4.44249C23.3651 3.89318 22.9348 3.46148 22.3862 3.2749C21.7546 3.06008 20.7732 3.43054 18.8105 4.17143L5.89218 9.04777C3.88366 9.80591 2.87932 10.1851 2.54763 10.771C2.25954 11.2798 2.22756 11.8945 2.46126 12.4306C2.73031 13.0478 3.68988 13.5291 5.60886 14.4917L9.20589 16.296C9.53484 16.461 9.69941 16.5435 9.84188 16.6537C9.96831 16.7513 10.0816 16.865 10.179 16.9917C10.2888 17.1344 10.3709 17.2991 10.5349 17.6285Z"
                stroke="#2F0640"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_839_17891">
                <rect width="25.52" height="25.52" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div> */}

        <p className="text-[#828282] text-sm whitespace-pre-line">
          <span
            className={twMerge(
              "max-w-full",
              !fullDescription && "line-clamp-2"
            )}
          >
            {description}
          </span>
          {!fullDescription && (
            <span
              onClick={() => setFullDescription(true)}
              role="button"
              className="text-purpleBg"
            >
              Read more
            </span>
          )}
        </p>

        {praiseReportData?.mediaType === "video" && (
          <PlayVideo
            id={`report_${praiseReportData.id}`}
            src={praiseReportData?.mediaUrl}
          />
        )}
      </div>
    );
  }
);

export default PraiseReportItem;

export const praiseReportList = [
  {
    avatar: avatar,
    fullname: "Tomi Edah",
    time: "3hrs ago",
    title: "God healed my Fingers!",
    image: praiseReport1,
    likes: 20,
    description:
      "Lorem ipsum dolor sit amet consectetur. Nisi facilisis sed urna proin neque ornare fusce. Non nisi vitae risus nunc sed gravida ipsum aliquet. Massa commodo",
  },
  {
    avatar: praiseReport2,
    fullname: "Blessing Oboh",
    time: "3hrs ago",
    title:
      "Miracle Job immediately After the 2nd day of Fasting and Prayer Service.",
    image: praiseReport2,
    likes: 20,
    description:
      "Lorem ipsum dolor sit amet consectetur. Nisi facilisis sed urna proin neque ornare fusce. Non nisi vitae risus nunc sed gravida ipsum aliquet. Massa commodo",
  },
];
